import { render, staticRenderFns } from "./DetailTechnologiDialog.vue?vue&type=template&id=042b825f&"
import script from "./DetailTechnologiDialog.vue?vue&type=script&lang=js&"
export * from "./DetailTechnologiDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports